import { render, staticRenderFns } from "./BubbleInput.vue?vue&type=template&id=f7b21112&"
import script from "./BubbleInput.vue?vue&type=script&lang=js&"
export * from "./BubbleInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports